import React from 'react'
import style from './Profile.Module.css'
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
// import background from '../../images/Group231.png'
import profileImage from '../../images/profile_image.jpeg'


const Profile = () => {
    return (
        
        <div className={style.body}>
            <section className={style.wrapper}>
            <div className={style.card}>
                <p className={style.uploadInfo}>Add three of your your coolest picture and get people liking.</p>
                <div className={style.uploadImageContainer}>
                    <div className={`${style.uploadImage1} ${style.cameraInputContainer}`}>
                    <span><i className="fas fa-upload"></i></span>
                        <p> Drag picture to Upload</p>
                    </div>
                    <div className={`${style.uploadImage} ${style.fileInputContainer}`}>
                    <img className={style.pic} src={profileImage} alt=''/>
                        
                    </div>

                    <div className={`${style.uploadImage} ${style.fileInputContainer}`}> </div>

                    <div className={`${style.uploadImage} ${style.fileInputContainer}`}> </div>
                
                </div>
                <div className={style.button}> <p> Choose File </p></div>

                <form className={style.form}>
                    <p className={style.p}>Please fill your details. this will take a few seconds.</p>
                    <div className={style.formContainer}>
                        <div className={style.formGroupContainer1}>
                            <div className={style.formGroup}>
                                <label className={style.label} htmlFor="username">Username</label>
                                <input className={style.input}  type="text" name="username" id="username"/>
                            </div>
                            <div className={style.formGroup}>
                                <label className={style.label} htmlFor="age">Age</label>
                                <input className={style.input}  type="number" name="age" id="age"/>
                            </div>
                            <div className={style.formGroup}>
                                <label className={style.label} htmlFor="bio">Bio</label>
                                <input className={style.input}  type="text" name="bio" id="bio"/>
                            </div>
                        </div>
                        <div className={style.formGroupContainer2}>
                            <div className={style.formGroup}>
                                <label className={style.label} htmlFor="location">Location</label>
                                <input className={style.input}  type="text" name="location" id="location"/>
                            </div>
                            <div className={style.formGroup}>
                                <label className={style.label} htmlFor="gender">Gender</label>
                                <input className={style.input}  type="text" name="gender" id="gender"/>
                            </div>
                            <div className={style.formGroup}>
                                <label className={style.label} htmlFor="phone">Phone number</label>
                                <input className={style.input}  type="tel" name="phone" id="phone"/>
                            </div>
                        </div>
                    </div>
                    <Link to="#" className={style.btn1}>Next</Link>
            
                            
                </form>
            </div>
            
        </section>
 </div>
    )
}

export default Profile

